<template>
  <table class="timeslot-item__table --desktop">
    <thead>
      <tr>
        <th class="guest-label">
          {{ tc('spaSoft.step1.guestTimeDateSelection.guestFieldLabel', {
            guestNumber: index + 1
          }) }}
        </th>
        <th>{{ tc('spaSoft.step1.itinerarySelection.timeSlotTimeLabel') }}</th>
        <th>{{ tc('spaSoft.step1.itinerarySelection.timeSlotTreatmentLabel') }}</th>
        <th>{{ tc('spaSoft.step1.itinerarySelection.timeSlotDurationLabel') }}</th>
        <th>{{ tc('spaSoft.step1.itinerarySelection.timeSlotTherapistLabel') }}</th>
        <th>{{ tc('spaSoft.step1.itinerarySelection.timeSlotPriceLabel') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(itinerary, i) in guestData.itinerary"
        :key="`guest-${i}`"
      >
        <td />
        <td>{{ getStartEndLabel(itinerary) }}</td>
        <td>{{ getTreatmentName({guestNumber: index, itinerary}) }}</td>
        <td class="duration">{{ getTreatmentDuration({guestNumber: index, itinerary}) }}</td>
        <td class="gender">{{ getGenderPreference({guestNumber: index, itinerary}) }}</td>
        <td class="price">{{ getPriceWithIsoCode({guestNumber: index, itinerary}) }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
  import { mapGetters } from 'vuex'
  import TimeslotTableMixin from './timeslot-table'

  export default {
    name: 'TimeslotTableDesktop',
    mixins: [TimeslotTableMixin],
    props: {
      guestData: {
        type: Object,
        required: true
      },
      index: {
        type: Number,
        required: true
      }
    },
    computed: {
      ...mapGetters('i18n', ['tc'])
    }
  }
</script>
